import { render, staticRenderFns } from "./displayController.vue?vue&type=template&id=99747b94&"
import script from "./displayController.vue?vue&type=script&lang=ts&"
export * from "./displayController.vue?vue&type=script&lang=ts&"
import style0 from "./displayController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports